import styled from 'styled-components'
import { Image } from '@farewill/ui'

const Texture = styled(Image)`
  pointer-events: none;
  position: absolute;
`

export default Texture
